import { render, staticRenderFns } from "./RecordStoryButton.vue?vue&type=template&id=4c825bec&scoped=true&"
import script from "./RecordStoryButton.vue?vue&type=script&lang=ts&"
export * from "./RecordStoryButton.vue?vue&type=script&lang=ts&"
import style0 from "./RecordStoryButton.vue?vue&type=style&index=0&id=4c825bec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c825bec",
  null
  
)

export default component.exports